<template>
    <div>
        <!--   New folder Modal   -->
        <div class="modal fade" id="newFolderModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLongTitle">{{ title }} folder</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeNewFolderModal()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body bg-white">
                        <div class="w-100 mb-3">
                            <label>Folder Name</label>
                            <input type="text" v-model="folderName" class="form-control border-grey-light shadow-none">
                        </div>
                        <div class="w-100 mb-3 container px-4">
                            <input class="form-check-input pointer-cursor" v-model="isAChildFolder" type="checkbox" value="" id="isAChildFolder">
                            <label class="form-check-label text-grey-darkest text-sm pointer-cursor" for="isAChildFolder">
                                Is a child folder
                            </label>
                        </div>
                        <div class="w-100 mb-3" v-if="isAChildFolder">
                            <label>Select Parent Folder</label>
                            <treeselect v-model="parentFolder" :options="filteredAllFolder"/>
                        </div>
                        <div class="w-100 container px-4">
                            <input class="form-check-input pointer-cursor" type="checkbox" v-model="sharedWithCompany" id="sharedWithCompany">
                            <label class="form-check-label text-grey-darkest text-sm pointer-cursor" for="sharedWithCompany">
                                Share with company
                            </label>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="closeNewFolderModal()">Close</button>
                        <button type="button" class="btn btn-primary" @click="saveOrUpdateSnippetFolder()">{{ title }}</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import axios from "axios";
import Treeselect from "@riophae/vue-treeselect";
export default {
    name: "snippets-new-folder-modal",
    props:['selectedFolderForEdit', 'allFolders'],
    components: {Treeselect, Multiselect},
    data() {
        return {
            title: (this.selectedFolderForEdit)? 'Update':'Create',
            parentFolder: null,
            isLoading: true,
            folderName: '',
            isAChildFolder: false,
            sharedWithCompany: false,

        };
    },
    mounted(){
        if(this.allFolders){
            this.isLoading = false;
        }
    },
    methods: {
        newFolderModal(){
            this.dataForEdit();
            $('#newFolderModal').modal('show');
        },
        closeNewFolderModal(){
            this.parentFolder = null;
            this.folderName = '';
            this.isAChildFolder = false;
            this.sharedWithCompany = false;
            this.$parent.selectedFolderForEdit = null;
            $('#newFolderModal').modal('hide');
            this.$parent.showHideSnippetPopover();
        },
        saveOrUpdateSnippetFolder(){
            let self = this;
            if(this.folderName.trim() === ''){
                this.getToast().fire({
                    type: 'error',
                    title: 'Please provide a valid folder name'
                });
                return false;
            }

            if(this.selectedFolderForEdit){
                if(this.selectedFolderForEdit.id == this.parentFolder){
                    this.getToast().fire({
                        type: 'error',
                        title: 'You can not select same folder as parent'
                    });
                    return false;
                }
            }

            let data = {
                selectedFolderForEdit: this.selectedFolderForEdit,
                parentFolder: this.parentFolder,
                folderName: this.folderName,
                isAChildFolder: (this.isAChildFolder)? 'true':'false',
                sharedWithCompany: (this.sharedWithCompany)? 'true':'false'
            }

            axios.post(route('snippet.folder.create-or-update'), data).then(response => {
                this.getToast().fire({
                    type: 'success',
                    title: response.data.message
                });

                if(data.parentFolder){
                    this.$parent.fetchDataOfFolder(this.parentFolder);
                    this.closeNewFolderModal();
                }else{
                    this.closeNewFolderModal();
                    this.$parent.getData();
                }
            });
        },
        dataForEdit(){
            if(this.selectedFolderForEdit){
                if(this.selectedFolderForEdit.parent_id){
                    this.parentFolder = this.selectedFolderForEdit.parent_id;
                    this.isAChildFolder = true;
                }

                this.folderName = this.selectedFolderForEdit.name;
                this.sharedWithCompany =(this.selectedFolderForEdit.is_shared == 1)? true:false;
                this.title = 'Update';
            }else{
                this.title = 'Create';
            }
        }
    },
    watch: {
        'allFolders': function (val, oldVal) {
            if(this.allFolders){
                this.isLoading = false;
            }
        }
    },
    computed: {
        filteredAllFolder(){
            return this.allFolders.filter(item => {
               if(this.selectedFolderForEdit){
                   if(item.id !== this.selectedFolderForEdit.id){
                       return item;
                   }
               }else{
                   return item;
               }
            });
        }
    }
};
</script>
<style>
    #newFolderModal .multiselect__spinner{
        height: 90% !important;
    }
</style>
